import {
  MetaConfig,
  TikTokConfig,
  YouTubeConfig,
} from '../../../../../../store/planStore';

const getConfigSaturationNullish = (
  minMaxValues?: MetaConfig | YouTubeConfig | TikTokConfig
) => {
  return (
    minMaxValues?.saturationMin === null &&
    minMaxValues?.saturationMax === null &&
    minMaxValues?.saturationDefault === null
  );
};

export default getConfigSaturationNullish;
